import { HerdService } from "./herdService";

const herdService = new HerdService();
export default herdService;
